/**
 * Hamburger Menu
 * SP用ハンバーガーメニューの開閉を制御
 */

const hamburger = document.getElementById('hamburger');
const spMenu = document.getElementById('sp-menu');

if (hamburger && spMenu) {
  function closeMenu() {
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'メニューを開く');
    spMenu.classList.remove('is-open');
    spMenu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-menu-open');
  }

  function openMenu() {
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'メニューを閉じる');
    spMenu.classList.add('is-open');
    spMenu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-menu-open');
  }

  hamburger.addEventListener('click', () => {
    if (spMenu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // メニュー内リンククリックで閉じる
  spMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
}
